import styled from 'styled-components'

export const AlertContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  gap: ${props => props.theme.spacing.sp8};

  p {
    padding-top: ${props => props.theme.spacing.sp4};
  }

  svg {
    min-width: ${props => props.theme.size.S};
  }
`
